import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EntiteModel } from 'src/models/pilotage/contextePilotageUtilisateurModel';

@Component({
    selector: 'app-move-user-root-dialog',
    templateUrl: './move-user-root-dialog.component.html',
    imports: [
        CommonModule,
        MatSelectModule,
        NgxMatSelectSearchModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule
    ]
})
export class MoveUserRootDialogComponent implements OnInit {
  entiteFilterCtrl: FormControl = new FormControl();
  filteredEntites: ReplaySubject<EntiteModel[]> = new ReplaySubject<EntiteModel[]>(1);
  protected _onDestroy = new Subject<void>();
  selectedEntite: number | null = null;

  constructor(
    public dialogRef: MatDialogRef<MoveUserRootDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      entities: EntiteModel[],
      userName: string,
      userId: number
    }
  ) { }

  ngOnInit() {
    this.filteredEntites.next(this.data.entities.slice());

    this.entiteFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterEntites();
      });
  }

  private filterEntites() {
    let search = this.entiteFilterCtrl.value;
    if (!search) {
      this.filteredEntites.next(this.data.entities.slice());
      return;
    }
    search = search.toLowerCase();
    this.filteredEntites.next(
      this.data.entities.filter(entity =>
        entity.nom.toLowerCase().indexOf(search) > -1)
    );
  }

  onSave() {
    if (this.selectedEntite) {
      this.dialogRef.close({
        utilisateurId: this.data.userId,
        nouvelleEntiteId: this.selectedEntite
      });
    }
  }
  onCancel() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
